import { Popconfirm, Space, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg, TrashSvg } from "src/components/Svg"
import styled from "styled-components";

export function getColumns(onDelete, onEdit) {
  return [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
      width: 300,
      sorter: (a, b) => a.date - b.date
    },
    {
      title: "Точки",
      dataIndex: "points",
      key: "points",
    },
    {
      title: "Интервалы",
      dataIndex: "intervals",
      key: "intervals",
      render: (text) => (
          <div>
            {text.map((iterval, idx) => <StyledTag key={idx} color="default">{`${iterval.start}-${iterval.end}`}</StyledTag>)}
          </div>
      )
    },
    ...(onEdit || onDelete ? [{
      title: "Действие",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space size="small">
          {onEdit && (
            <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
              <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                <PencilSvg />
              </Button>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
              <Popconfirm
                placement="left"
                title="Действительно хотите удалить?"
                onConfirm={() => onDelete(record.id)}
                onCancel={() => stopPropagation}
              >
                <Button size="small" type="link" onClick={stopPropagation}>
                  <TrashSvg />
                </Button>
              </Popconfirm>
            </Tooltip>
          )}
        </Space>
      ),
    }] : []),
  ]
}

const stopPropagation = (e) => {
  e?.stopPropagation()
}

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`
